
import React, {Component, useEffect, useState} from 'react';
import ReactPaginate from "react-paginate";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import '../../Common/css/Pagination.css';
import Text from '../../../common/Text.js';

//total : 전체 데이터 기준
//limit : 현재 페이지 데이터 개수
//page  : 현재 페이지 1개 => 1
//setPage : 

 


const Pagination = ({total, limit, page, setPage, offset}) =>
    {
        useEffect(() => {


            console.log('total:'+total);
            console.log('limit:'+limit);
            console.log('page:'+page);
           

            if(total>=1)
            {
                 
           console.log(total);
           console.log('total?');
                const elem = document.getElementById('number0');
                console.log(elem);
                elem.style.backgroundColor = "#0C4DA2";
                setcurrentPG(0);
            }
             
        
          }, []);

    const numPages = Math.ceil(total/limit);
    const [currentPG, setcurrentPG] = useState(0); //현재 선택된 페이지 번호

    function BtnClick(i){

        setcurrentPG(i);
        setPage(i+1) ;

 
    Array(numPages).fill(0).map((_, a) => { document.getElementById('number' + a).style.backgroundColor = "#D8D8D8";
    });
      
//document.getElementById('number' + a).style.backgroundColor = "#adadad"

       const elem = document.getElementById('number' + i);

       elem.style.backgroundColor = "#0C4DA2";
    }


    
    function PreButton(){

        console.log(currentPG);
        setPage(page-1);

 

      const elem = document.getElementById(`number${currentPG-1}`);
        
      console.log(elem);
      Array(numPages).fill(0).map((_, a) => { document.getElementById('number' + a).style.backgroundColor = "#D8D8D8"});
    elem.style.backgroundColor = "#0C4DA2";
    setcurrentPG(currentPG-1);
    }

     
    function NextButton(){

        console.log(currentPG);
        setPage(page + 1);

 
       const elem = document.getElementById(`number${currentPG+1}`);
        
      console.log(elem);
      console.log(elem);
      console.log(elem);
      Array(numPages).fill(0).map((_, a) => { document.getElementById('number' + a).style.backgroundColor = "#D8D8D8"});
      elem.style.backgroundColor = "#0C4DA2";
       setcurrentPG(currentPG+1);
    }


    return(
        <div className="pagepanel2">
            <button className="btns" onClick={() => PreButton()} disabled={page === 1}> 
            
            <Text variant="px18" >
                    <div >이전</div>
            </Text>
  
            </button>
            {Array(numPages)
            .fill()
            .map((_, i)=>(
                <button id = {'number' + i} className="number" 
                key={i+1}
                onClick={() =>  BtnClick(i)}
                aria-current={page === i+1 ? "page" : null}
                >  {i+1} 
        </button>
            ))}
            <button  className="btns" 
            onClick={() => NextButton()}
            disabled={page === numPages}>
                 
            <Text variant="px18" >
                    <div >다음</div>
            </Text></button>
        </div>
    )
}

export default Pagination;
